/**
 * Map tool-prep keys / titles → invite landing pages for post-download share.
 * Goal: grow the app via the tool they just loved (not share the output file).
 */

import { getInviteLanding } from "../app/referralInviteLandings";

const TOOL_KEY_TO_LANDING = {
  resize: "resize",
  crop: "resize",
  circle_crop: "resize",
  circleCrop: "resize",
  padding: "resize",
  watermark: "general",
  watermark_maker: "general",
  shadow: "shadow",
  outline: "shadow",
  background_color: "white-background",
  backgroundColor: "white-background",
  white_background: "white-background",
  black_background: "white-background",
  blur: "general",
  gaussian_blur: "general",
  pixel_blur: "general",
  motion_blur: "general",
  bokeh_blur: "general",
  background_blur: "general",
  rotate: "general",
  flip: "general",
  background_remover: "remove-background",
  backgroundRemover: "remove-background",
  ai_background_remover: "remove-background",
  remove_bg: "remove-background",
  ai_background: "ai-background",
  ai_background_image: "ai-background",
  background_image: "ai-background",
  backgroundImage: "ai-background",
  ai_passport_photo_maker: "passport-size-photo",
  passport: "passport-size-photo",
  ai_shadow: "shadow",
  ai_upscale: "general",
  ai_enhance: "general",
  upscale: "general",
  enhance: "general",
  outpaint: "general",
  ai_expand: "general",
  recolor: "general",
  ai_recolor: "general",
  relight: "general",
  ai_relight: "general",
};

const TITLE_HINTS = [
  { match: /passport/i, landingId: "passport-size-photo" },
  { match: /background remover|remove background/i, landingId: "remove-background" },
  { match: /ai background|background image/i, landingId: "ai-background" },
  { match: /white background|black background|background color/i, landingId: "white-background" },
  { match: /shadow|outline/i, landingId: "shadow" },
  { match: /resize|crop|padding/i, landingId: "resize" },
];

/**
 * @param {object} opts
 * @param {string} [opts.toolKey]
 * @param {string} [opts.shareTitle]
 * @returns {{ landingId: string, toolLabel: string, toolBlurb: string }}
 */
export function resolveToolPrepShareContext({
  toolKey = "",
  shareTitle = "LazyStudio",
} = {}) {
  const key = String(toolKey || "").trim();
  let landingId = TOOL_KEY_TO_LANDING[key] || null;

  if (!landingId && shareTitle) {
    const hit = TITLE_HINTS.find((h) => h.match.test(shareTitle));
    landingId = hit?.landingId || "general";
  }
  if (!landingId) landingId = "general";

  const landing = getInviteLanding(landingId);
  const title = String(shareTitle || "").replace(/\s+tool$/i, "").trim();
  const toolLabel =
    landingId === "general" && title && title !== "LazyStudio"
      ? title
      : landing.label;
  const toolBlurb =
    landingId === "general" && title && title !== "LazyStudio"
      ? title.toLowerCase()
      : landing.blurb;

  return { landingId, toolLabel, toolBlurb };
}
